import moment from "moment";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import UserPicker from "../../../controls/UserPicker";
import Loading from "../../../cross/Loading";
import { EnumEstadoAuditoria } from "../../../entities/helper/EnumEstadoAuditoria";
import { EnumEstadoProgramaAuditoria } from "../../../entities/helper/EnumEstadoProgramaAuditoria";
import { IComboboxOption } from "../../../entities/helper/IComboboxOption";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import IUserPickerValue from "../../../entities/helper/IUserPickerValue";
import IAuditoria from "../../../entities/IAuditoria";
import IGerencia from "../../../entities/IGerencia";
import IPrograma from "../../../entities/IPrograma";
import { ITipoAuditoria } from "../../../entities/ITipoAuditoria";
import { ITipoUnidadAuditar } from "../../../entities/ITipoUnidadAuditar";
import IUnidad from "../../../entities/IUnidad";
import IVicePresidencia from "../../../entities/IVicePresidencia";
import { shortDate } from "../../../helpers/dateHelper";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { cognitoUserToken, cognitoUserInfo } from "../../../helpers/userHelper";
import {
  ROW_COUNT,
  API_AUDITORIA,
  API_AUDITORIA_GET_PROGRAMAAUDITORIA,
  API_AUDITORIA_GETALL_PLANESAUDITORIAS,
  URL_SUPPORT,
  API_ADMIN_TIPO_AUDITORIA,
  API_ADMIN_GERENCIA,
  API_ADMIN_UNIDAD,
  API_AUDITORIA_POST_AUDITORIA,
  API_ADMIN_TIPO_UNIDAD_AUDITAR,
  API_AUDITORIA_GET_AUDITORIA,
  API_AUDITORIA_POST_AUDITORIA_APROBARAUDITORIA,
} from "../../../helpers/variableHelper";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AuditoriaService from "../../../services/AuditoriaService";
import VppService from "../../../services/VppService";
import { cParamsActiveOrderNombre, cParamsActiveOrderTitle, cParamsActive } from "../../../helpers/paramsHelper";
const MySwal = withReactContent(Swal);

interface IAgregarAuditoriaProps {
  loading?: boolean;
  cbAllTipoAuditoria?: Array<ITipoAuditoria>;
  auditoriaTest?: IAuditoria;
  is_Test?: boolean;
  auditoriaIdTest?: string;
  formDisabledTest?: boolean;
}

export default function AgregarAuditoria({
  loading,
  auditoriaIdTest = "0",
  cbAllTipoAuditoria,
  auditoriaTest,
  is_Test = false,
  formDisabledTest,
}: IAgregarAuditoriaProps) {
  let search = new URLSearchParams(window.location.search);
  const idPrograma = parseInt(search.get("id") || "0");
  const idAuditoria = parseInt(search.get("idauditoria") || auditoriaIdTest);

  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading ?? true);

  const [auditoriaSeleccionada, setAuditoriaSeleccionada] = useState<IAuditoria | null>(null);
  const [programaSeleccionado, setProgramaSeleccionado] = useState<IPrograma | null>(null);
  const [allTipoAuditoria, setAllTipoAuditoria] = useState<Array<ITipoAuditoria>>(cbAllTipoAuditoria || []);
  const [allVicepresidencia, setAllVicepresidencia] = useState<Array<IVicePresidencia>>([]);
  const [allGerencia, setAllGerencia] = useState<Array<IGerencia>>([]);
  const [allUnidad, setAllUnidad] = useState<Array<IUnidad>>([]);
  const [allUnidadAuditar, setAllUnidadAuditar] = useState<Array<ITipoUnidadAuditar>>([]);

  const refTxtObjetivoAlcance = React.createRef<HTMLTextAreaElement>();
  const [lenObjetivoAlcance, setLenObjetivoAlcance] = useState(0);
  const refTxtFechaDesde = React.createRef<HTMLInputElement>();
  const refTxtFechaHasta = React.createRef<HTMLInputElement>();
  const refTxtNombreAuditorExterno = React.createRef<HTMLInputElement>();
  const refTxtOrganizacionAuditorExterno = React.createRef<HTMLInputElement>();

  const [valTipoAuditoria, setValTipoAuditoria] = useState<IComboboxOption | null>(null);
  const [valUnidadAuditoria, setValUnidadAuditoria] = useState<Array<number>>([]);
  const [valVicepresidencia, setValVicepresidencia] = useState<IComboboxOption | null>(null);
  const [valGerencia, setValGerencia] = useState<IComboboxOption | null>(null);
  const [valUnidad, setValUnidad] = useState<IComboboxOption | null>(null);
  const [valResponsableArea, setValResponsableArea] = useState<IUserPickerValue | null>(null);
  const [valAuditorLider, setValAuditorLider] = useState<IUserPickerValue | null>(null);
  const [valAuditoresParticipantes, setValAuditoresParticipantes] = useState<IUserPickerValue[] | null>(null);
  const [valTieneAuditorExterno, setValTieneAuditorExterno] = useState<string>("No");
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [lenTxtNombreAuditorExterno, setLenTxtNombreAuditorExterno] = useState<number>(0);
  const [lenTxtOrganizacionAuditorExterno, setLenTxtOrganizacionAuditorExterno] = useState<number>(0);
  const [isFormDisabled, setIsFormDisabled] = useState(formDisabledTest ?? true);
  const [isSendingData, setIsSendingData] = useState(false);

  usePromiseEffect(async () => {
    // NOSONAR Dejamos justificado que estas validaciones corresponden a validacion de propiedades en la carga del formulario
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    setIsLoading(true);

    let resultGetPrograma = is_Test
      ? { data: { ID_ESTADO: 2 } }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GET_PROGRAMAAUDITORIA}`,
            { Authorization: `Bearer ${token}` },
            { ...cParamsActive, PAGINADO: ROW_COUNT, ID: idPrograma }
          )
        ).result;
    setProgramaSeleccionado(resultGetPrograma.data);

    let resultAllTipoAuditoria: Array<ITipoAuditoria> = is_Test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderNombre)).result
          .data;
    setAllTipoAuditoria(resultAllTipoAuditoria);

    let resultAllVicepresidencia = is_Test ? { data: [] } : (await VppService.getAll(token, cParamsActiveOrderTitle)).result;
    setAllVicepresidencia(resultAllVicepresidencia.data);

    if (idAuditoria) {
      let resultGetAuditoria: IAuditoria = is_Test
        ? {
            OBJETIVO_ALCANCE_EXCLUSIONES: [],
            ID_ESTADO: 2,
            VICEPRESIDENCIA: "1",
            GERENCIA_SUBGERENCIA: "1",
            UNIDAD_A_AUDITAR: [],
          }
        : (await getAPI(`${API_AUDITORIA}${API_AUDITORIA_GET_AUDITORIA}`, { Authorization: `Bearer ${token}` }, { ID: idAuditoria })).result;
      setLenObjetivoAlcance(resultGetAuditoria.OBJETIVO_ALCANCE_EXCLUSIONES.length);
      setIsFormDisabled(resultGetAuditoria.ID_ESTADO >= EnumEstadoAuditoria.AuditoriaAprobada);
      let resultAllFilterGerencia = is_Test
        ? { data: [] }
        : (
            await getAPI(
              `${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`,
              { Authorization: `Bearer ${token}` },
              {
                ...cParamsActiveOrderTitle,
                VICEPRESIDENCIA: resultGetAuditoria.VICEPRESIDENCIA,
              }
            )
          ).result;
      setAllGerencia(resultAllFilterGerencia.data);

      let resultAllUnidad: Array<IUnidad> = is_Test
        ? []
        : (
            await getAPI(
              `${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`,
              { Authorization: `Bearer ${token}` },
              {
                ...cParamsActiveOrderTitle,
                NOMBRE_GERENCIA_SUBGERENCIA: resultGetAuditoria.GERENCIA_SUBGERENCIA,
              }
            )
          ).result.data;
      setAllUnidad(resultAllUnidad);

      setAuditoriaSeleccionada(resultGetAuditoria);
      setValTieneAuditorExterno(resultGetAuditoria.AUDITOR_EXTERNO ? "Sí" : "No");
      setValTipoAuditoria({
        value: resultGetAuditoria.ID_TIPO_AUDITORIA?.toString() || "",
        label: "",
      });
      setValUnidadAuditoria(resultGetAuditoria.UNIDAD_A_AUDITAR);
      setValVicepresidencia({
        value: resultGetAuditoria.ID_VICEPRESIDENCIA?.toString() || "",
        label: resultGetAuditoria.VICEPRESIDENCIA || "",
      });
      setValGerencia({
        value: resultGetAuditoria.ID_GERENCIA_SUBGERENCIA?.toString() || "",
        label: resultGetAuditoria.GERENCIA_SUBGERENCIA || "",
      });
      setValUnidad({
        value: resultGetAuditoria.ID_UNIDAD_PROYECTO?.toString() || "",
        label: resultGetAuditoria.UNIDAD_PROYECTO || "",
      });
      setValResponsableArea({
        mail: resultGetAuditoria.RESPONSABLE_AREA,
        name: resultGetAuditoria.RESPONSABLE_AREA_DISPLAY,
      });
      setValAuditorLider({
        mail: resultGetAuditoria.AUDITOR_LIDER,
        name: resultGetAuditoria.AUDITOR_LIDER_DISPLAY,
      });
      let mailsAuditoresParticipantes = resultGetAuditoria.AUDITORES_ACOMPANANTES.split("; ");
      let namesAuditoresParticipantes = resultGetAuditoria.AUDITORES_ACOMPANANTES_DISPLAY.split("; ");
      let arrayAuditoresParticipantes: IUserPickerValue[] = [];
      mailsAuditoresParticipantes.forEach((mailAuditor, index) => {
        if (mailAuditor !== "") {
          arrayAuditoresParticipantes.push({
            mail: mailAuditor,
            name: namesAuditoresParticipantes[index],
            image: "https://p16-tiktok-va-h2.ibyteimg.com/img/musically-maliva-obj/1624828413449221~c5_720x720.jpeg",
          });
        }
      });
      setValAuditoresParticipantes(arrayAuditoresParticipantes);
      setLenTxtNombreAuditorExterno(resultGetAuditoria.NOMBRE_AUDITOR_EXTERNO?.length || 0);
      setLenTxtOrganizacionAuditorExterno(resultGetAuditoria.ORGANIZACION_AUDITOR_EXTERNO?.length || 0);

      let resultAllUnidadAuditar = is_Test
        ? {
            data: [
              {
                ACTIVO: true,
                AUTOR: "",
                EDITOR: "",
                FECHA_MODIFICACION: new Date(),
                ID_TIPO_AUDITORIA: 1,
                NOMBRE: "",
                ORDENADOPOR: "",
                ORIENTACION: "",
                PAGINA: 1,
                PAGINADO: 1,
                TIPO_AUDITORIA: "",
                FECHA_CREACION: new Date(),
                ID: 1,
                TRANSACTION_ID: "",
              },
            ] as ITipoUnidadAuditar[],
          }
        : (
            await getAPI(
              `${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}/getall`,
              { Authorization: `Bearer ${token}` },
              {
                ...cParamsActive,
                TIPO_AUDITORIA: resultAllTipoAuditoria.filter((ta) => ta.ID == resultGetAuditoria.ID_TIPO_AUDITORIA)[0].NOMBRE,
                ACTIVO: true,
              }
            )
          ).result;
      setAllUnidadAuditar(resultAllUnidadAuditar.data);
    } else {
      setIsFormDisabled(false);
    }

    let resultGetAllAntecedentes: Array<IAuditoria> = is_Test
      ? { data: [] }
      : (
          await getAPI(
            `${API_AUDITORIA}${API_AUDITORIA_GETALL_PLANESAUDITORIAS}`,
            { Authorization: `Bearer ${token}` },
            { ...cParamsActive, PAGINADO: 1, ID_PROGRAMA_AUDITORIA: idPrograma }
          )
        ).result.data;
    console.log(resultGetAllAntecedentes);

    setIsLoading(false);
  }, []);

  const formValidation = (value: Partial<IAuditoria>): boolean => {
    // NOSONAR Dejamos justificado que estas validaciones corresponden a validacion de campos de los formularios de auditoría
    let arrErrors: Array<string> = [];
    if (!value.ID_TIPO_AUDITORIA) {
      arrErrors.push("TIPO_AUDITORIA");
    }
    if (!value.UNIDAD_A_AUDITAR?.length) {
      arrErrors.push("UNIDAD_AUDITAR");
    }
    if (!value.OBJETIVO_ALCANCE_EXCLUSIONES) {
      arrErrors.push("OBJETIVO_ALCANCE_EXCLUSIONES");
    }
    if (!value.ID_VICEPRESIDENCIA) {
      arrErrors.push("VICEPRESIDENCIA");
    }
    if (!value.ID_GERENCIA_SUBGERENCIA) {
      arrErrors.push("GERENCIA_SUBGERENCIA");
    }
    if (!value.ID_UNIDAD_PROYECTO) {
      arrErrors.push("UNIDAD_PROYECTO");
    }
    if (!moment(value.FECHA_DESDE).isValid()) {
      arrErrors.push("FECHA_DESDE");
    }
    if (!moment(value.FECHA_HASTA).isValid()) {
      arrErrors.push("FECHA_HASTA");
    }

    if (moment(value.FECHA_DESDE).isValid() && moment(value.FECHA_HASTA).isValid()) {
      if (moment(value.FECHA_DESDE) > moment(value.FECHA_HASTA)) {
        MySwal.fire({
          html: (
            <div>
              <h3>Fecha hasta debe ser mayor que la fecha desde</h3>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
        arrErrors.push("FECHA_HASTA");
      }
    }

    if (!value.RESPONSABLE_AREA && !value.RESPONSABLE_AREA_DISPLAY) {
      arrErrors.push("RESPONSABLE_AREA");
    }
    if (!value.AUDITOR_LIDER && !value.AUDITOR_LIDER_DISPLAY) {
      arrErrors.push("AUDITOR_LIDER");
    }
    if (value.AUDITOR_LIDER && value.RESPONSABLE_AREA && value.AUDITOR_LIDER === value.RESPONSABLE_AREA) {
      arrErrors.push("AUDITOR_LIDER");
      arrErrors.push("RESPONSABLE_AREA");
      MySwal.fire({
        html: (
          <div>
            <h3>Responsable Área no puede ser igual a auditor líder</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }
    if (value.AUDITOR_LIDER && value.AUDITORES_ACOMPANANTES && esAuditorParticipante(value.AUDITORES_ACOMPANANTES, value.AUDITOR_LIDER)) {
      arrErrors.push("AUDITORES_ACOMPANANTES_DISPLAY");
      MySwal.fire({
        html: (
          <div>
            <h3>El Auditor Participante no puede ser Auditor Líder</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }
    if (value.RESPONSABLE_AREA && value.AUDITORES_ACOMPANANTES && esAuditorParticipante(value.AUDITORES_ACOMPANANTES, value.RESPONSABLE_AREA)) {
      arrErrors.push("RESPONSABLE_AREA");
      MySwal.fire({
        html: (
          <div>
            <h3>El responsable del área auditar no puede ser el Auditor Participante</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }
    if (value.AUDITOR_EXTERNO) {
      if (!value.NOMBRE_AUDITOR_EXTERNO) {
        arrErrors.push("NOMBRE_AUDITOR_EXTERNO");
      }
      if (!value.ORGANIZACION_AUDITOR_EXTERNO) {
        arrErrors.push("ORGANIZACION_AUDITOR_EXTERNO");
      }
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const esAuditorParticipante = (users: string | undefined, emailUser: string) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  const saveData = async (): Promise<number> => {
    let mailsAuditoresParticipantes = "";
    let namesAuditoresParticipantes = "";
    valAuditoresParticipantes?.forEach((auditor) => {
      mailsAuditoresParticipantes += auditor.mail + "; ";
      namesAuditoresParticipantes += auditor.name + "; ";
    });
    let resultId = 0;
    const value: Partial<IAuditoria> = {
      ID: auditoriaSeleccionada?.ID,
      ID_PROGRAMA_AUDITORIA: idPrograma,
      CORRELATIVO: auditoriaSeleccionada?.CORRELATIVO,
      ID_TIPO_AUDITORIA: parseInt(valTipoAuditoria?.value || ""),
      OBJETIVO_ALCANCE_EXCLUSIONES: refTxtObjetivoAlcance.current?.value,
      ID_VICEPRESIDENCIA: parseInt(valVicepresidencia?.value || ""),
      ID_GERENCIA_SUBGERENCIA: parseInt(valGerencia?.value || ""),
      ID_UNIDAD_PROYECTO: parseInt(valUnidad?.value || ""),
      FECHA_DESDE: new Date(refTxtFechaDesde.current?.value || ""),
      FECHA_HASTA: new Date(refTxtFechaHasta.current?.value || ""),
      RESPONSABLE_AREA: valResponsableArea?.mail,
      RESPONSABLE_AREA_DISPLAY: valResponsableArea?.name,
      AUDITOR_LIDER: valAuditorLider?.mail,
      AUDITOR_LIDER_DISPLAY: valAuditorLider?.name,
      AUDITORES_ACOMPANANTES: mailsAuditoresParticipantes.slice(0, -2),
      AUDITORES_ACOMPANANTES_DISPLAY: namesAuditoresParticipantes.slice(0, -2),
      AUDITOR_EXTERNO: valTieneAuditorExterno === "Sí",
      NOMBRE_AUDITOR_EXTERNO: refTxtNombreAuditorExterno.current?.value,
      NOMBRE_AUDITOR_EXTERNO_DISPLAY: "",
      ORGANIZACION_AUDITOR_EXTERNO: refTxtOrganizacionAuditorExterno.current?.value,
      AUTOR: auditoriaSeleccionada?.AUTOR || currentUser?.email,
      AUTOR_DISPLAY: auditoriaSeleccionada?.AUTOR_DISPLAY || currentUser?.fullname,
      EDITOR: auditoriaSeleccionada?.EDITOR,
      EDITOR_DISPLAY: auditoriaSeleccionada?.EDITOR_DISPLAY,
      FECHA_CREACION: auditoriaSeleccionada?.FECHA_CREACION || new Date(),
      FECHA_MODIFICACION: auditoriaSeleccionada?.FECHA_MODIFICACION,
      ID_ESTADO: EnumEstadoAuditoria.EnConstruccion,
      UNIDAD_A_AUDITAR: valUnidadAuditoria,
    };
    let f = formValidation(value);
    if (f) {
      let r = (await postAPI(`${API_AUDITORIA}${API_AUDITORIA_POST_AUDITORIA}`, value, { Authorization: `Bearer ${token}` })).result;
      resultId = r.data.data;
    }
    return resultId;
  };

  const aprobar = async () => {
    setIsSendingData(true);
    let dataInsertAuditoria = is_Test ? 1 : await saveData();
    if (dataInsertAuditoria > 0) {
      let mailsAuditoresParticipantes = "";
      let namesAuditoresParticipantes = "";
      valAuditoresParticipantes?.forEach((auditor) => {
        mailsAuditoresParticipantes += auditor.mail + "; ";
        namesAuditoresParticipantes += auditor.name + "; ";
      });
      const result = is_Test
        ? { httpCode: 200, result: {} }
        : await postAPI(
            `${API_AUDITORIA}${API_AUDITORIA_POST_AUDITORIA_APROBARAUDITORIA}`,
            {
              ID: dataInsertAuditoria,
              EDITOR: currentUser?.email,
              EDITOR_DISPLAY: currentUser?.fullname,
              FECHA_MODIFICACION: new Date(),
              ENVIAR_NOTIFICACION: true,
              RESPONSABLE_AREA: valResponsableArea?.mail,
              RESPONSABLE_AREA_DISPLAY: valResponsableArea?.name,
              AUDITORES_ACOMPANANTES_DISPLAY: namesAuditoresParticipantes.slice(0, -2),
              AUDITORES_ACOMPANANTES: mailsAuditoresParticipantes.slice(0, -2),
            },
            { Authorization: `Bearer ${token}` }
          );
      console.log(result);

      if (programaSeleccionado?.ID_ESTADO === EnumEstadoProgramaAuditoria.ProgramaAprobado) {
        AuditoriaService.GenerarPDFPrograma(token, idPrograma);
      }
      setTimeout(() => {
        window.location.href = `detalleprograma?id=${idPrograma}`;
      }, 2000);
    }
    setIsSendingData(false);
  };

  const validateError = (error: string) => {
    return arrErrorEmpty.includes(error) && "error";
  };
  return (
    <div className="row">
      <button
        hidden={true}
        data-testid="btnformvalidation"
        onClick={() => {
          formValidation(auditoriaTest ?? {});
        }}></button>
      <button
        hidden={true}
        data-testid="btnsave"
        onClick={() => {
          saveData();
        }}></button>
      <button
        hidden={true}
        data-testid="btnaprobartest"
        onClick={() => {
          aprobar();
        }}></button>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit">Auditoría</h1>

              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion">Auditoría</span>
                    </h6>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>Código de Auditoría</label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    <label>{auditoriaSeleccionada?.CORRELATIVO}</label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Tipo Auditoría
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <Select
                        placeholder="Seleccione"
                        defaultValue={
                          allTipoAuditoria
                            .filter((ta) => ta.ID === auditoriaSeleccionada?.ID_TIPO_AUDITORIA)
                            .map((ta) => {
                              return { value: ta.ID, label: ta.NOMBRE };
                            })
                            .pop() || ""
                        }
                        className={`${validateError("TIPO_AUDITORIA")}`}
                        isClearable={true}
                        noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                        options={allTipoAuditoria.map((i) => ({
                          value: i.ID as number,
                          label: i.NOMBRE,
                        }))}
                        onChange={async (e: any) => {
                          setValTipoAuditoria(e);
                          let resultAllUnidadAuditar = (
                            await getAPI(
                              `${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}/getall`,
                              { Authorization: `Bearer ${token}` },
                              {
                                ...cParamsActive,
                                TIPO_AUDITORIA: e.label,
                                ACTIVO: true,
                              }
                            )
                          ).result;
                          setAllUnidadAuditar(resultAllUnidadAuditar.data);
                          setValUnidadAuditoria([]);
                        }}
                        isDisabled={isFormDisabled}
                      />
                    ) : (
                      <label>{auditoriaSeleccionada?.TIPO_AUDITORIA}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Ámbito de Auditoría
                    </label>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    <div className={`form-control form-control-sm w-50 ${validateError("UNIDAD_AUDITAR")}`}>
                      {allUnidadAuditar.map((ua) => {
                        return (
                          <div key={ua.ID}>
                            <input
                              data-testid={`chktestauditar${ua.ID}`}
                              type="checkbox"
                              id={`chk${ua.ID}`}
                              name={`chk${ua.ID}`}
                              value={ua.ID}
                              defaultChecked={auditoriaSeleccionada?.UNIDAD_A_AUDITAR.includes(ua.ID as number)}
                              checked={valUnidadAuditoria.includes(ua.ID as number)}
                              onChange={(e) => {
                                const val = parseInt(e.target.value);
                                if (valUnidadAuditoria.includes(val)) {
                                  setValUnidadAuditoria(valUnidadAuditoria.filter((ua) => ua !== val));
                                } else {
                                  setValUnidadAuditoria([...valUnidadAuditoria, val]);
                                }
                              }}
                              disabled={isFormDisabled}
                            />
                            <label htmlFor={`chk${ua.ID}`}>{ua.NOMBRE}</label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Objetivo, Alcance y Exclusiones
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <span>
                        <textarea
                          className={`form-control form-control-sm w-50 ${validateError("OBJETIVO_ALCANCE_EXCLUSIONES")}`}
                          rows={3}
                          ref={refTxtObjetivoAlcance}
                          defaultValue={auditoriaSeleccionada?.OBJETIVO_ALCANCE_EXCLUSIONES}
                          disabled={isFormDisabled}
                          maxLength={250}
                          onChange={(e) => {
                            setLenObjetivoAlcance(e.target.value.length);
                          }}></textarea>
                        <span>{lenObjetivoAlcance}/250</span>
                      </span>
                    ) : (
                      <label>{auditoriaSeleccionada?.OBJETIVO_ALCANCE_EXCLUSIONES}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Vicepresidencia
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <Select
                        placeholder="Seleccione"
                        defaultValue={
                          allVicepresidencia
                            .filter((ta) => ta.ID == auditoriaSeleccionada?.ID_VICEPRESIDENCIA)
                            .map((ta) => ({ value: ta.ID, label: ta.TITULO }))
                            .pop() || ""
                        }
                        className={`${validateError("VICEPRESIDENCIA")}`}
                        isClearable={true}
                        noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                        options={allVicepresidencia.map((i) => ({
                          value: i.ID,
                          label: i.TITULO,
                        }))}
                        onChange={async (e: any) => {
                          setValVicepresidencia(e);
                          setValGerencia(null);
                          setAllGerencia([]);
                          setValUnidad(null);
                          setAllUnidad([]);
                          let resultAllGerencia = (
                            await getAPI(
                              `${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`,
                              { Authorization: `Bearer ${token}` },
                              { ...cParamsActiveOrderTitle, VICEPRESIDENCIA: e.label }
                            )
                          ).result;
                          setAllGerencia(resultAllGerencia.data);
                        }}
                        isDisabled={isFormDisabled}
                      />
                    ) : (
                      <label>{auditoriaSeleccionada?.VICEPRESIDENCIA}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Gerencia/Subgerencia
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <Select
                        placeholder="Seleccione"
                        value={valGerencia || null}
                        defaultValue={
                          allGerencia
                            .filter((ta) => ta.ID === auditoriaSeleccionada?.ID_GERENCIA_SUBGERENCIA)
                            .map((ta) => {
                              return { value: ta.ID, label: ta.TITULO };
                            })
                            .pop() || ""
                        }
                        className={`${validateError("GERENCIA_SUBGERENCIA") && "error"}`}
                        isClearable={true}
                        noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                        options={allGerencia.map((i) => ({
                          value: i.ID,
                          label: i.TITULO,
                        }))}
                        onChange={async (e: any) => {
                          setValGerencia(e);

                          setValUnidad(null);
                          setAllUnidad([]);

                          let resultAllUnidad: Array<IUnidad> = (
                            await getAPI(
                              `${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`,
                              { Authorization: `Bearer ${token}` },
                              {
                                ...cParamsActiveOrderTitle,
                                NOMBRE_GERENCIA_SUBGERENCIA: e.label,
                              }
                            )
                          ).result.data;
                          setAllUnidad(resultAllUnidad);
                        }}
                        isDisabled={isFormDisabled}
                      />
                    ) : (
                      <label>{auditoriaSeleccionada?.GERENCIA_SUBGERENCIA}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Unidad/Proyecto
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <Select
                        placeholder="Seleccione"
                        defaultValue={
                          allUnidad
                            .filter((ta) => ta.ID === auditoriaSeleccionada?.ID_UNIDAD_PROYECTO)
                            .map((ta) => {
                              return { value: ta.ID, label: ta.TITULO };
                            })
                            .pop() || ""
                        }
                        className={`${validateError("UNIDAD_PROYECTO")}`}
                        isClearable={true}
                        noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                        options={allUnidad.map((i) => ({
                          value: i.ID,
                          label: i.TITULO,
                        }))}
                        onChange={async (e: any) => {
                          setValUnidad(e);
                        }}
                        isDisabled={isFormDisabled}
                      />
                    ) : (
                      <label>{auditoriaSeleccionada?.UNIDAD_PROYECTO}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Fecha Desde
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <input
                        data-testid="dtfechadesdetest"
                        className={`${validateError("FECHA_DESDE")}`}
                        type="date"
                        ref={refTxtFechaDesde}
                        defaultValue={moment(auditoriaSeleccionada?.FECHA_DESDE).format("yyyy-MM-DD") || ""}
                        onChange={() => {
                          if (moment(refTxtFechaDesde.current?.value) > moment(refTxtFechaHasta.current?.value)) {
                            (refTxtFechaHasta.current as HTMLInputElement).value = moment(refTxtFechaDesde.current?.value).format("yyyy-MM-DD");
                          }
                        }}
                        disabled={isFormDisabled}
                      />
                    ) : (
                      <label>{shortDate(auditoriaSeleccionada?.FECHA_DESDE)}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Fecha Hasta
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <input
                        data-testid="dtfechahastatest"
                        className={`${validateError("FECHA_HASTA")}`}
                        type="date"
                        ref={refTxtFechaHasta}
                        defaultValue={moment(auditoriaSeleccionada?.FECHA_HASTA).format("yyyy-MM-DD") || ""}
                        disabled={isFormDisabled}
                      />
                    ) : (
                      <label>{shortDate(auditoriaSeleccionada?.FECHA_DESDE)}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Responsable del área a Auditar
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <UserPicker
                        name={"usrResponsableArea"}
                        callback={(id: string, value: Array<IUserPickerValue>) => {
                          setValResponsableArea(value[0] || null);
                        }}
                        id={""}
                        key={"1"}
                        multi={false}
                        disabled={isFormDisabled}
                        defaultValue={valResponsableArea}
                        className={`${validateError("RESPONSABLE_AREA")}`}
                      />
                    ) : (
                      <label>{auditoriaSeleccionada?.RESPONSABLE_AREA_DISPLAY}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>
                      <span hidden={isFormDisabled} className="text-danger">
                        (*)
                      </span>{" "}
                      Auditor Líder
                    </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <UserPicker
                        name={"usrResponsableArea"}
                        callback={(id, value) => {
                          setValAuditorLider(value[0] || null);
                        }}
                        id={""}
                        multi={false}
                        disabled={isFormDisabled}
                        defaultValue={valAuditorLider}
                        className={`${validateError("AUDITOR_LIDER")}`}
                      />
                    ) : (
                      <label>{auditoriaSeleccionada?.AUDITOR_LIDER_DISPLAY}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>Auditores Participantes</label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <UserPicker
                        name={"usrResponsableArea"}
                        callback={(id: string, value: Array<IUserPickerValue>) => {
                          setValAuditoresParticipantes(value);
                        }}
                        id={""}
                        key={"1"}
                        multi={true}
                        disabled={isFormDisabled}
                        defaultValue={valAuditoresParticipantes}
                        className={`${validateError("AUDITORES_PARTICIPANTES") && "error"}`}
                      />
                    ) : (
                      <label>{auditoriaSeleccionada?.AUDITORES_ACOMPANANTES_DISPLAY}</label>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>Cuenta con Auditor Externo</label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    {!isFormDisabled ? (
                      <span>
                        <div className="form-check form-check-inline">
                          <input
                            data-testid="chkauditortestsi"
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio1"
                            value="Sí"
                            defaultChecked={auditoriaSeleccionada?.AUDITOR_EXTERNO}
                            onClick={(e) => {
                              if ((e.target as HTMLInputElement).checked) {
                                setValTieneAuditorExterno((e.target as HTMLInputElement).value);
                                setLenTxtNombreAuditorExterno(0);
                                setLenTxtOrganizacionAuditorExterno(0);
                                try {
                                  (refTxtNombreAuditorExterno.current as HTMLInputElement).value = "";
                                  (refTxtNombreAuditorExterno.current as HTMLInputElement).value = "";
                                } catch (e) {
                                  console.log(e);
                                }
                              }
                            }}
                            disabled={isFormDisabled}
                          />
                          <label className="form-check-label" htmlFor="inlineRadio1">
                            Si
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            data-testid="chkauditortestno"
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio2"
                            value="No"
                            defaultChecked={!auditoriaSeleccionada?.AUDITOR_EXTERNO}
                            onClick={(e) => {
                              if ((e.target as HTMLInputElement).checked) {
                                setValTieneAuditorExterno((e.target as HTMLInputElement).value);
                                setLenTxtNombreAuditorExterno(0);
                                setLenTxtOrganizacionAuditorExterno(0);
                                (refTxtNombreAuditorExterno.current as HTMLInputElement).value = "";
                                (refTxtNombreAuditorExterno.current as HTMLInputElement).value = "";
                              }
                            }}
                            disabled={isFormDisabled}
                          />
                          <label className="form-check-label" htmlFor="inlineRadio2">
                            No
                          </label>
                        </div>
                      </span>
                    ) : (
                      <label>{auditoriaSeleccionada?.AUDITOR_EXTERNO ? "Sí" : "No"}</label>
                    )}
                  </div>
                  {valTieneAuditorExterno === "Sí" && (
                    <>
                      <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                        <label>
                          <span hidden={isFormDisabled} className="text-danger">
                            (*)
                          </span>{" "}
                          Nombre Auditor Externo
                        </label>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                        {!isFormDisabled ? (
                          <input
                            className={`${validateError("NOMBRE_AUDITOR_EXTERNO")}`}
                            type="text"
                            ref={refTxtNombreAuditorExterno}
                            defaultValue={auditoriaSeleccionada?.NOMBRE_AUDITOR_EXTERNO}
                            onChange={() => setLenTxtNombreAuditorExterno(refTxtNombreAuditorExterno.current?.value.length || 0)}
                            disabled={isFormDisabled}
                            maxLength={250}
                          />
                        ) : (
                          <label>{auditoriaSeleccionada?.NOMBRE_AUDITOR_EXTERNO}</label>
                        )}
                        <span>
                          <small hidden={isFormDisabled}>{lenTxtNombreAuditorExterno}/250</small>
                        </span>
                      </div>
                    </>
                  )}
                  {valTieneAuditorExterno === "Sí" && (
                    <>
                      <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                        <label>
                          <span hidden={isFormDisabled} className="text-danger">
                            (*)
                          </span>{" "}
                          Organización Auditor Externo
                        </label>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                        {!isFormDisabled ? (
                          <input
                            className={`${validateError("ORGANIZACION_AUDITOR_EXTERNO")}`}
                            type="text"
                            ref={refTxtOrganizacionAuditorExterno}
                            defaultValue={auditoriaSeleccionada?.ORGANIZACION_AUDITOR_EXTERNO}
                            onChange={() => setLenTxtOrganizacionAuditorExterno(refTxtOrganizacionAuditorExterno.current?.value.length || 0)}
                            disabled={isFormDisabled}
                            maxLength={250}
                          />
                        ) : (
                          <label>{auditoriaSeleccionada?.ORGANIZACION_AUDITOR_EXTERNO}</label>
                        )}
                        <span>
                          <small hidden={isFormDisabled}>{lenTxtOrganizacionAuditorExterno}/250</small>
                        </span>
                      </div>
                    </>
                  )}
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                    {!isFormDisabled && (
                      <span>
                        <button
                          type="button"
                          data-testid="btngrabar"
                          className="btn btn-sm btn-primary me-2"
                          onClick={async () => {
                            setIsSendingData(true);
                            let dataInsertAuditoria = await saveData();
                            if (dataInsertAuditoria > 0) {
                              window.location.href = `detalleprograma?id=${idPrograma}`;
                            }
                            setIsSendingData(false);
                          }}
                          disabled={isSendingData}>
                          {" "}
                          Grabar
                        </button>
                        {programaSeleccionado?.ID_ESTADO === EnumEstadoProgramaAuditoria.ProgramaAprobado && (
                          <button
                            type="button"
                            data-testid="btnaprobar"
                            className="btn btn-sm btn-outline-primary"
                            onClick={async () => {
                              await aprobar();
                            }}
                            disabled={isSendingData}>
                            Aprobar
                          </button>
                        )}
                      </span>
                    )}
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary ms-1"
                      onClick={() => {
                        window.location.href = `detalleprograma?id=${idPrograma}`;
                      }}
                      disabled={isSendingData}>
                      Volver
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
